/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CustomFieldListPathParams, CustomFieldListResponse } from '../types/CustomFieldList'

/**
 * GET /:organisation/custom_fields/:location
 * @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::list
 */
export async function customFieldList(
	organisation: CustomFieldListPathParams['organisation'],
	location: CustomFieldListPathParams['location'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomFieldListResponse>> {
	return axiosInstance.get(`/${organisation}/custom_fields/${location}`, config)
}
